import { useEffect, useState } from "react";
import { Button, FileButton, Switch } from "@mantine/core";

import { convertToBase64 } from "./../../../../utils/fileToBase64";
import VariableSelectCreate from "../../../GlobalComponent/VariableSelectCreate";
import VariableNumberInput from "../../../GlobalComponent/VariableNumberInput";

function ImageSearch(props) {
  const [dataState, setDataState] = useState(
    props?.nodeData?.data?.options ?? {
      image: "",
      outputVariableX: "",
      outputVariableY: "",
      timeout: "30000",
      filetype: "",
      isFullScreen: false,
    }
  );

  const onChangeValue = (key, target) => (e) => {
    if (e?.type === "change") {
      setDataState((state) => ({
        ...state,
        [key]: target ? e.target[target] : e.target.value,
      }));
    } else if (e?.type === "click") {
      const value = e.target.getAttribute("value");
      const newValue = dataState[key] + "${" + value + "}";
      setDataState((state) => ({ ...state, [key]: newValue }));
    } else {
      setDataState((state) => ({ ...state, [key]: e }));
    }
  };

  const onChangeImage = async (file) => {
    const base64 = await convertToBase64(file);
    onChangeValue("image")(base64);
    onChangeValue("filetype")(file.type);
  };

  useEffect(() => {
    props.handleSetDataBaseModal(dataState)
}, [props, dataState])

  return (
    <div>
      <div>
        <FileButton onChange={onChangeImage} accept="image/png,image/jpeg">
          {(props) => <Button {...props}>Choose image</Button>}
        </FileButton>
      </div>
      {dataState?.image && (
        <div style={{ marginTop: 12, marginBottom: 12, textAlign: "center" }}>
          <img
            alt=""
            src={dataState?.image}
            style={{ maxHeight: 120, width: "auto", maxWidth: "100%" }}
          />
        </div>
      )}
      <Switch
        label="Take a full screen"
        checked={dataState.isFullScreen}
        style={{ marginTop: 12 }}
        onChange={onChangeValue("isFullScreen", "checked")}
      />
      <VariableSelectCreate
        label="X Coordinates Output Variable"
        placeholder="Select items"
        value={dataState.outputVariableX}
        handleChange={onChangeValue("outputVariableX")}
      />
      <VariableSelectCreate
        label="Y Coordinates Output Variable"
        placeholder="Select items"
        value={dataState.outputVariableY}
        handleChange={onChangeValue("outputVariableY")}
      />
      <VariableNumberInput
        label="Timeout waiting (milliseconds)"
        dataState={dataState.timeout}
        handleData={onChangeValue("timeout")}
        isMillisecond={true}
      />
    </div>
  );
}

export default ImageSearch;
